import script from "./AccordionRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccordionRadio.vue?vue&type=script&lang=ts&setup=true"

import "./AccordionRadio.vue?vue&type=style&index=0&id=6ae12234&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae12234"]])

export default __exports__